import { render, staticRenderFns } from "./AppButton.vue?vue&type=template&id=a660d8ee&"
import script from "./AppButton.js?vue&type=script&lang=js&"
export * from "./AppButton.js?vue&type=script&lang=js&"
import style0 from "./AppButton.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports